import React from 'react';
import PropTypes from 'prop-types';

import './ResourceContentCard.scss';
import ResponsivePicture from '../ResponsivePicture/ResponsivePicture';
import FGBLabel from '../FGBLabel/FGBLabel';
import ContentTitle from '../ContentTitle/ContentTitle';
import {
    singleResourceIdShape,
    singleResourceContentUrlShape,
    singleResourceImageShape,
    singleResourceTitleShape,
    singleResourceMarketingTagShape,
} from '../../Includes/employerPropTypes';

export default class ResourceContentCard extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        id: singleResourceIdShape,
        image: singleResourceImageShape,
        contentUrl: singleResourceContentUrlShape,
        title: singleResourceTitleShape,
        marketingTag: singleResourceMarketingTagShape,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onClick: () => {},
    };

    render() {
        const breakpoints = {
            mobile: {
                width: 300,
                height: 169,
                transforms: {
                    crop: 'fill',
                    gravity: 'faces',
                },
            },
        };
        return (
            <div className="component-Elements-ResourceContentCard">
                <div className={'content-controlled-width'}>
                    <a
                        className="main-link"
                        href={this.props.contentUrl}
                        onClick={this.props.onClick}
                    >
                        <ResponsivePicture
                            cloudinaryID={this.props.image.src}
                            breakpoints={breakpoints}
                        />
                    </a>
                    <a
                        className={'marketing-tag-url'}
                        href={this.props.marketingTag.url}
                    >
                        <FGBLabel>{this.props.marketingTag.name}</FGBLabel>
                    </a>
                    <a
                        className="main-link"
                        href={this.props.contentUrl}
                        onClick={this.props.onClick}
                    >
                        <ContentTitle>{this.props.title}</ContentTitle>
                    </a>
                </div>
            </div>
        );
    }
}
